import { createFileRoute, Navigate, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/projects/$projectId/')({
  component: () => {
    const { projectId } = useParams({ from: '/projects/$projectId/' });
    return <Navigate to="/projects/$projectId/applications" params={{ projectId }} />;
  },
});
